import {
  ADD_USER,
  DELETE_USER,
  UPDATE_USER,
  USERS_ERROR,
  USERS_REQUEST,
  USERS_SUCCESS,
  USERS_ADD_NOTIFICATION,
  USERS_CLEAN_NOTIFICATION,
} from './types';

const initialState = {
  data        : [],
  error       : null,
  loading     : false,
  notification: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_USER:
      return {
        ...state,
        data: [...state.data, action.user],
      };
    case DELETE_USER:
      return {
        ...state,
        data: state.data.filter(item => item._id !== action.user._id),
      };
    case UPDATE_USER:
      return {
        ...state,
        data: state.data.map((item) => {
          if (item._id === action.user._id) {
            return { ...item, ...action.user };
          }
          return item;
        }),
      };
    case USERS_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case USERS_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case USERS_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    case USERS_ADD_NOTIFICATION:
      return {
        ...state,
        notification: action.notification,
      };
    case USERS_CLEAN_NOTIFICATION:
      return {
        ...state,
        notification: initialState.notification,
      };
    default:
      return state;
  }
}
